(function () {
	'use strict';
	angular.module('app.core')
		.service('supplyChainReportColumns', supplyChainReportColumns);

	supplyChainReportColumns.$inject = (['$rootScope', '$experiments', 'columnsService', 'flexColumns', 'tableRenderService', 'siteService', '$translate']);
	function supplyChainReportColumns($rootScope, $experiments, columnsService, flexColumns, tableRenderService, siteService, $translate) {

		var currentCustomerSites = Object.keys(globalConfig.user.authFacts).filter(function (site) {
			return globalConfig.user.authFacts[site].customerNdx === globalConfig.customer.id;
		});
		var scorecardSettings = getScorecardSettings(currentCustomerSites);
		var clearToBuildEnabled = currentCustomerSites.filter(function (site) {
			return globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.GenerateClearToBuild === '1';
		}).length > 0;
		var clearToBuildv2Enabled = currentCustomerSites.filter(function (site) {
			return globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.GenerateClearToBuildFlattenedReqs === '1';
		}).length > 0;

		var supplyOrderForecastEnabled = $experiments.isEnabled('supply-order-forecast');

		var supplierReports = {
			'MATERIAL_SHORTAGES': [
				{ name: 'SBI', columns: getShortageByItemColumns, additionalFlag: false },
				{ name: 'SBO', columns: getShortageByOrderColumns },
				{ name: 'MinMax', columns: getItemReportMinMaxUnderMinColumns },
				{ name: 'SafetyStock', columns: getItemReportUnderSafetyStockColumns }
			],
			'LINE_OF_BALANCE': [{ name: 'LOB', columns: getShortageByItemColumns, additionalFlag: true }],
			'PURCHASE_ORDERS': [{ name: 'PO', columns: getPurchaseOrderReportColumns }],
			'PURCHASE_ORDERS_RECEIPTS': [{ name: 'POR', columns: getPurchaseOrderReceiptsReportColumns }],
			'PURCHASE_REQUISITIONS': [{ name: 'PR', columns: getRequisitionReportColumns }],
			'PLAN_FOR_EVERY_PART_PURCHASED': [{ name: 'PP', columns: getItemReportTargetSavingsColumns }],
			'SUPPLIER_PERFORMANCE_SUMMARY': [{ name: 'SPM', columns: getSupplierPerformanceLastMonthColumns }, { name: 'SPR', columns: getSupplierPerformanceRollingAverageColumns }],
			'WORKBENCH': [{ name: 'WORKBENCH', columns: getWorkbenchReportColumns }],
			'REACT_REPORT_EXCLUSIVE': [{ name: 'REACT_REPORT_EXCLUSIVE', columns: getReactExclusiveColumns}],
			'SUPPLIER_ON_HAND_INVENTORY': [{ name: 'SUPPLIER_ON_HAND_INVENTORY', columns: getSupplierOnHandInventoryColumns }]
		};
		var EXCLUDED_ACTION_COLUMNS = [
			'taskId', 'actionStatusNdx', 'actionStatus', 'taskStatus', 'actionIsActive', 'actionCategoryNdx',
			'isActiveCategory', 'actionCategory', 'taskCategory', 'actionSubject', 'actionOwnerNdx', 'responsibleNdx',
			'actionOwner', 'actionDescription', 'actionDueDate', 'actionCreator', 'creatorNdx', 'actionCreaterNdx',
			'actionCompletedDate', 'actionCreatedDate', 'actionLastUpdateDate', 'actionReviewLaterExpireDate',
			'lastComment', 'lastCommenter', 'lastCommentDate', 'allComments'];

		function getScorecardSettings(sites) {
			return {
				scorecardCostPerfEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardCostPerf === '1';
				}).length > 0,
				scorecardQualityPerfEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardQualityPerf === '1';
				}).length > 0,
				scorecardDelPerfEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardDelPerf === '1';
				}).length > 0,
				scorecardDelPerfEarlyEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardDelPerfEarly === '1';
				}).length > 0,
				scorecardDelPerfLateEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardDelPerfLate === '1';
				}).length > 0,
				scorecardVmiOverMaxPerfEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardVmiOverMaxPerf === '1';
				}).length > 0,
				scorecardVmiBelowMinPerfEnabled: sites.filter(function (site) {
					return globalConfig.user.authFacts[site] && globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShowScorecardVmiBelowMinPerf === '1';
				}).length > 0
			};
		}

		return {
			getSupplyOrderReportColumns: getSupplyOrderReportColumns,
			getPurchaseOrderReportColumns: getPurchaseOrderReportColumns,
			getPurchaseOrderReceiptsReportColumns: getPurchaseOrderReceiptsReportColumns,
			getRequisitionReportColumns: getRequisitionReportColumns,
			getShortageByItemColumns: getShortageByItemColumns,
			getShortageByOrderColumns: getShortageByOrderColumns,
			getSupplierPerformanceLastMonthColumns: getSupplierPerformanceLastMonthColumns,
			getSupplierPerformanceRollingAverageColumns: getSupplierPerformanceRollingAverageColumns,
			getItemReportMinMaxUnderMinColumns: getItemReportMinMaxUnderMinColumns,
			getItemReportUnderSafetyStockColumns: getItemReportUnderSafetyStockColumns,
			getItemReportTargetSavingsColumns: getItemReportTargetSavingsColumns,
			getSupplierReportColumns: getSupplierReportColumns,
			getWorkbenchReportColumns: getWorkbenchReportColumns,
			getRequiredColumns: getRequiredColumns
		};

		function getSupplierOnHandInventoryColumns() {
			var columns = [
				{ id: 'itemCode', display: 'Item Code' },
				{ id: 'factoryName', display: 'Site' },
				{ id: 'supplierName', display: 'Supplier' },
				{ id: 'itemUom', display: 'UOM' },
				{ id: 'itemDescription', display: 'Item Description' },
				{ id: 'analysisAvgDailyDemandFloat', display: 'Company defined demand (daily)' },
				{ id: 'supplierOnHandQuantity', display: 'Supplier on hand quantity', requiredForReport: true },
				{ id: 'lastQuantityUpdate', display: 'Last quantity update', requiredForReport: true },
				{ id: 'supplierOnHandDaysCoverage', display: 'Supplier on hand days coverage' }
			];

			return $experiments.isEnabled('react-supplier-on-hand-inventory') ? columns : [];
		}

		// get the columns that exclusive to react reports.  This way to avoid need to manually exclude them from angular reports while make them available in the supplier connect.
		function getReactExclusiveColumns(isSupplierConfig, isSupplier) {
			var columns = [];
			if ($experiments.isEnabled('workbench')) {
				columns.push({
					id: 'state',
					display: 'Status (Workbench)',
					show: true,
					width: 100
				});
			}
			if ($experiments.isEnabled('root-cause-category-columns')) {
				columns.push({
					id: 'rootCauseCategoryDescription',
					display: 'Root cause category',
					show: false,
					width: 100,
					renderer: tableRenderService.shortageRootCauseCategory
				});
				columns.push({
					id: 'rootCauseComment',
					display: 'Root cause comment',
					show: false,
					width: 100,
					renderer: tableRenderService.shortageRootCauseComment
				});
			}
			if ($experiments.isEnabled('workbench')) {
				columns.push({
					id: 'rejectionReason',
					display: 'Send back reason',
					show: true,
					width: 100
				});
			}
			if ($experiments.isEnabled('workbench')) {
				columns.push({
					id: 'poAdjustmentSupplierAction',
					display: 'Action (Workbench)',
					show: true,
					width: 100
				});
			}
			columns.push({
				id: 'firstPurchaseOrderPromiseDate',
				display: 'Supply Order Current Supplier Commit Date',
				show: false,
				width: 100
			});
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		};
		function getSupplyOrderReportColumns(someFactoriesUseConfirmations, isAnyClearToBuildEnabled, isSupplier) {
			var columns = columnsService({
				actionStatus: 0,
				actionCategory: 0,
				actionOwner: 0,
				lastComment: 0,
				lastCommenter: 0,
				lastCommentDate: 0,
				actionDueDate: 0,
				itemCode: 1,
				poIdentifier: {show: true, display: 'Supply Order Identifier'},
				itemGroupName: 0,
				factoryName: 0,
				erpOrderPolicy: 0,
				supplierName: 1,
				buyerCode: 1,
				planner: 0,
				firstPoStatus: 0,
				firstPoEcdDate: {show: false, showApprovalModal: true},
				firstPoEcdLastModified: 0,
				poStatusCategoryDescription: 0,
				itemType: 0,
				documentType: 1,
				erpDocumentType: 0,
				materialGroup: 0,
				materialType: 0,
				orderCreationDate: 1,
				goldenSupplyDate: 1,
				originalRequestedDate: 1,
				confirmationStatusUsed: 0,
				rescheduleDate: 0,
				supplyOrderImpactingShortage: 0,
				promiseDate: {display: 'Commit Date', show : 1},
				actualReceiptDate: 1,
				deliveryStatus: 0,
				supplyOrderNumber: 1,
				orderLine: 1,
				scheduleLine: 1,
				totalOrderedQuantity: 1,
				remainingQuantityFloat: 1,
				deliveredQuantity: 1,
				firstPoTrackingNumber: 0,
				forecastTotalQuantity: 0,
				forecastDeliveryCount: 0,
				forecastFirstDeliveryQuantity: 0,
				forecastFirstDeliveryDate: 0,
				forecastFirstTrackingNumber: 0,
				forecastFirstComment: 0,
				itemUom: 1,
				unitPrice: 1,
				standardPrice: 1,
				erpStatus: 1,
				poValue: 0,
				poValueStandard: 0,
				poValuePPV: 0,
				poStatus: 1,
				leadTimeInDaysFloat: 0,
				poLeadTime: 0,
				actualLeadTime: 0,
				placementDaysLate: 0,
				validityStartDate: 0,
				validityEndDate: 0,
				fixedPOFlag: 0,
				excessAtOtherSites: 0,
				notes: 0,
				exceptionMessage: 1,
				isBlanketOrder: 0,
				businessUnit: 0,
				division: 0,
				entity: 0,
				peggingKey: 0,
				analysisRequirementDate: 0,
				clearToBuildPriority: { show: 1, disabled: !(isAnyClearToBuildEnabled) },
				location: 1
			});
			if (someFactoriesUseConfirmations) {
				columns = columns.concat(columnsService({
					confirmationDocumentId: 0,
					confirmationLine: 0,
					confirmationArrivalDate: 0,
					confirmedQuantity: 0,
					shipmentDocumentId: 0,
					shipmentLine: 0,
					shipmentArrivalDate: 0,
					shippedQuantity: 0
				}));
			}
			columns = flexColumns.addFlexColumnsBySourceType(['item', 'supply'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getPurchaseOrderReportColumns(someFactoriesUseConfirmations, isSupplier, excludeBlanketOrdersFilter) {
			var columns = columnsService({
				itemCode: { show: true, pinnedLeft: true },
				poIdentifier: 0,
				supplyOrderNumber: {  show: true, pinnedLeft: true, display: 'PO Number' },
				orderLine: {  show: true, pinnedLeft: true, display: 'PO Line' },
				scheduleLine: { show: true, pinnedLeft: true },
				goldenSupplyDate: { show: true, pinnedLeft: true, sortDefaultReverse: false },
				deliveryStatus: { show: true, pinnedLeft: true },
				firstPoStatus: 1,
				poStatusCategoryDescription: 1,
				originalRequestedDate: 1,
				promiseDate: 'Current Supplier Commit Date',
				scorecardDate: 1,
				deliveryScoreGroupingDate: 1,
				supplierName: 1,
				buyerCode: 1,
				supplyOrderImpactingShortage: 1,
				analysisRequirementDate: 1,
				clearToBuildPriority: { show: 1, disabled: !(clearToBuildEnabled || clearToBuildv2Enabled) },
				totalOrderedQuantity: 1,
				remainingQuantityFloat: 1,
				deliveredQuantity: 1,
				poAction: 1,
				analysisRescheduleDate: 1,
				exceptionMessage: 1,
				rescheduleDate: 1,
				unitPrice: 1,
				standardPrice: 1,
				leadTimeInDaysFloat: 1,
				poLeadTime: 'PO Lead Time',
				actualLeadTime: 1,
				actionStatus: 0,
				actionCategory: 0,
				actionOwner: 0,
				lastComment: 0,
				lastCommenter: 0,
				lastCommentDate: 0,
				actionDueDate: 0,
				itemAlias: 0,
				factoryAlias: 0,
				itemGroupName: 0,
				erpOrderPolicy: 0,
				firstPoStatusLastModified: 0,
				poStatus: 0,
				confirmDate: 0,
				confirmationStatusUsed: 0,
				planner: 0,
				itemType: 0,
				documentType: { show: 0, display: 'Purchase Document Type' },
				erpDocumentType: 0,
				materialGroup: 0,
				materialType: 0,
				orderCreationDate: { show: 0, display: 'Order Date' },
				depthOfDelay: 0,
				ageOfPoAction: 0,
				receiptDate: 0,
				lateDeliveryDescription: 0,
				lateDeliveryLiability: 0,
				itemUom: 0,
				poValue: { show: 0, display: 'Open PO Value (Unit Price)' },
				totalPoValue: { show: 0, display: 'Total PO Value (Unit Price)' },
				poValueStandard: 0,
				totalPoValueStandard: 0,
				poValuePPV: 0,
				placementDaysLate: 0,
				validityStartDate: 0,
				validityEndDate: 0,
				fixedPOFlag: 0,
				excessAtOtherSites: 0,
				notes: 0,
				erpStatus: 0,
				isBlanketOrder: {disabled: !excludeBlanketOrdersFilter},
				businessUnit: 0,
				entity: 0,
				division: 0,
				isMoveInForRequirement: 0,
				requestedShippingDate: 0,
				confirmedShippingDate: 0,
				actualShippedDate: 0,
				incoterms: 0
			});
			if (someFactoriesUseConfirmations) {
				columns = columns.concat(columnsService({
					confirmationDocumentId: 0,
					confirmationLine: 0,
					confirmationArrivalDate: 0,
					confirmedQuantity: 0,
					shipmentDocumentId: 0,
					shipmentLine: 0,
					shipmentArrivalDate: 0,
					shippedQuantity: 0
				}));
			}
			if (supplyOrderForecastEnabled) {
				columns = columns.concat(columnsService({
					forecastTotalQuantity: 0,
					forecastDeliveryCount: 0,
					forecastFirstDeliveryQuantity: 0,
					forecastFirstDeliveryDate: 0,
					forecastFirstTrackingNumber: 0,
					forecastFirstComment: 0
				}));
			} else {
				columns = columns.concat(columnsService({
					firstPoTrackingNumber: 1,
					firstPoEcdDate: {show: true, showApprovalModal: true},
					firstPoEcdLastModified: 0
				}));
			}
			columns = flexColumns.addFlexColumnsBySourceType(['item', 'supply'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getPurchaseOrderReceiptsReportColumns(isSupplierConfig, isSupplier) {
			var columns = [{
				'id': 'actionStatus',
				'width': 100,
				'display': 'Task Status',
				'class': 'taskStatusCell',
				'renderer': tableRenderService.status,
				'sort': false
			}, {
				'id': 'itemCode',
				'width': 200,
				'display': 'Item Code',
				'class': 'itemCodeCell',
				'renderer': tableRenderService.itemCode
			},
			{
				'id': 'factoryName',
				'display': 'Site',
				'width': 100
			}, {
				'id': 'itemGroup',
				'width': 60,
				'display': 'Item Group',
				'class': 'supplierCell',
				'show': false
			}, {
				'id': 'erpOrderPolicy',
				'width': 60,
				'display': 'ERP Order Policy',
				'class': 'smallTextCell',
				'show': false
			}, {
				'id': 'supplierName',
				'width': 120,
				'display': 'Supplier',
				'class': 'supplierCell'
			}, {
				'id': 'purchaseDocumentType',
				'width': 80,
				'display': 'Purchase Document Type',
				'class': 'buyerCell'
			}, {
				'id': 'orderDate',
				'width': 130,
				'display': 'Order Date',
				'class': 'dateCell',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'title': 'The PO placement date.'
			}, {
				'id': 'requestedDate',
				'width': 130,
				'display': 'Expected Delivery Date',
				'class': 'dateCell',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'title': 'The current expected delivery date for the order.'
			}, {
				'id': 'actualReceiptDate',
				'width': 130,
				'display': 'Actual Receipt Date',
				'class': 'dateCell',
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true,
				'title': 'The date that the item was actually received',
				'sortDefaultReverse': true
			}, {
				'id': 'purchaseOrderNumber',
				'width': 200,
				'display': 'PO Number',
				'class': 'buyerCell'
			}, {
				'id': 'purchaseOrderLine',
				'width': 60,
				'display': 'PO Line',
				'class': 'smallTextCell'
			}, {
				'id': 'scheduleLine',
				'display': 'Schedule Line',
				'width': 90,
				'show': false,
				'class': 'smallTextCell alignRight'
			}, {
				'id': 'quantity',
				'width': 60,
				'display': 'On Order Qty',
				'class': 'numberCell largeTitle alignRight',
				'renderer': tableRenderService.integer,
				'title': 'The requested quantity in the original PO'
			}, {
				'id': 'receivedQuantity',
				'width': 60,
				'display': 'Received Qty',
				'class': 'numberCell veryLargeTitle alignRight',
				'renderer': tableRenderService.integer,
				'title': 'The quantity received so far'
			}, {
				'id': 'invoiceAmount',
				'width': 80,
				'display': 'Invoice Amount',
				'class': 'buyerCell alignRight',
				'renderer': tableRenderService.currency,
				'keepAllDecimals': true
			}, {
				'id': 'unitPrice',
				'width': 130,
				'display': 'Unit Price',
				'class': 'buyerCell alignRight',
				'renderer': tableRenderService.currency,
				'keepAllDecimals': false
			},{
				'id': 'standardPrice',
				'width': 130,
				'display': 'Standard Price',
				'class': 'buyerCell alignRight',
				'renderer': tableRenderService.currency,
				'keepAllDecimals': false,
				'show': false
			},{
				'id': 'movingAveragePrice',
				'width': 130,
				'display': 'Moving Average Price',
				'class': 'buyerCell alignRight',
				'renderer': tableRenderService.currency,
				'keepAllDecimals': false,
				'show': false
			}, {
				'id': 'notes',
				'width': 120,
				'display': 'Notes',
				'class': 'buyerCell'
			}];
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getRequisitionReportColumns(isSupplierConfig, isSupplier) {
			var columns = columnsService({
				actionStatus: 1,
				actionSubject: 0,
				actionDescription: 0,
				actionCategory: 0,
				actionOwner: 0,
				actionDueDate: 0,
				lastComment: 0,
				lastCommenter: 0,
				lastCommentDate: 0,
				supplyOrderNumber: 'PR Number',
				businessUnit: 0,
				division: 0,
				entity: 0,
				factoryAlias: 1,
				itemCode: 1,
				itemType: 0,
				itemGroupName: 0,
				supplierName: 0,
				supplierCode: 0,
				buyerCode: 1,
				planner: 0,
				erpDocumentType: 0,
				externalMaterialGroup: 0,
				materialGroup: 0,
				materialType: 0,
				leadTimeInDaysFloat: 1,
				remainingQuantityFloat: 1,
				orderCreationDate: 'PR Creation Date',
				prOnTimeDate: 'PR On Time Date',
				poOnTimeFirmDate: 'PO On Time Firm Date',
				goldenSupplyDate: 1,
				notificationLeadTimeDays: 0,
				notificationLeadTimeWeeks: 0,
				daysInsideSupplierLeadTimeAtCreation: {display: 'Days Inside Supplier Lead Time at Creation', show: 0},
				daysInsideProcurementLeadTimeAtCreation: 0,
				daysUntilPOFirm: 'Days Until PO Firm',
				daysUntilProcurementLeadTime: 0,
				erpStatus: 1,
				erpOrderPolicy: 0,
				notes: 0,
				exceptionMessage: 1,
				excessAtOtherSites: 0,
				analysisRequirementDate: 0
			});
			columns = flexColumns.addFlexColumnsBySourceType(['item', 'supply'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getShortageByItemColumns(isSupplierConfig, isSupplier, addLobDefinition, isLobAllParts, enableForecastUI) {
			var columns = [
				{
					id: 'itemCode',
					display: 'Item Code',
					renderer: tableRenderService.itemCode,
					width: 180,
					pinnedLeft: true
				},
				{
					id: 'firstPurchaseOrder',
					display: 'Supply Order' + ($experiments.isEnabled('chat-enabled') ? ' Identifier': ''),
					width: 140,
					renderer: tableRenderService.firstPurchaseOrder,
					sort: true,
					sortDefaultReverse: true,
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'firstImpactedOrderDate',
					display: isLobAllParts ? 'Date of First Order Impacted by Shortage' : 'First Impacted Order Date',
					width: 140,
					renderer: tableRenderService.dateRenderer,
					convertTimeZone: true,
					pinnedLeft: true,
					sortDefaultReverse: false
				},
				{
					id: 'firstImpactedOrderQty',
					display: isLobAllParts ? 'Qty of First Order Impacted by Shortage' : 'First Impacted Order Quantity',
					width: 140,
					pinnedLeft: true
				},
				{
					id: 'firstPurchaseOrderDate',
					display: 'Supply Order Expected Delivery Date',
					width: 100,
					renderer: tableRenderService.firstPurchaseOrder,
					title: 'The current Requested Date for the Order.',
					convertTimeZone: true,
					sortDefaultReverse: false,
					peggingTooltip: 'First supply order requiring attention',
					pinnedLeft: true
				},
				{
					id: 'firstPurchaseOrderQty',
					display: 'Supply Order Qty',
					width: 100,
					renderer: tableRenderService.firstPurchaseOrder,
					peggingTooltip: 'First supply order requiring attention',
					pinnedLeft: true
				},
				{
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					width: 80,
					renderer: tableRenderService.hyperlinkShortage,
					pinnedLeft: true
				},
				{
					id: 'itemAlias',
					display: 'Item Alias',
					width: 180,
					show: false
				},
				{
					id: 'itemType',
					display: 'Item Type',
					width: 100,
					show: isLobAllParts
				},
				{
					id: 'siteAlias',
					display: 'Site',
					width: 100
				},
				{
					id: 'actionStatus',
					display: 'Task Status',
					renderer: tableRenderService.status,
					width: 120
				},
				{
					id: 'actionSubject',
					display: 'Task Subject',
					show: false,
					width: 120,
					sort: false
				},
				{
					id: 'actionDescription',
					display: 'Task Description',
					show: false,
					width: 150,
					sort: false,
					renderer: tableRenderService.uiBootstrapTooltip
				},
				{
					id: 'actionCategory',
					display: 'Task Category',
					width: 120,
					renderer: tableRenderService.inlineTaskList,
					idField: 'actionCategoryNdx'
				},
				{
					id: 'actionOwner',
					display: 'Task Responsible',
					renderer: tableRenderService.inlineTaskList,
					show: false,
					width: 120,
					idField: 'actionOwnerNdx'
				},
				{
					id: 'actionDueDate',
					display: 'Task Due Date',
					renderer: tableRenderService.inlineTaskDueDate,
					convertTimeZone: true,
					width: 100,
					statusColumn: 'actionStatus',
					statusForCheckingPastDue: 'Open',
					show: false
				},
				{
					id: 'lastComment',
					display: 'Last Comment',
					show: false,
					width: 120,
					renderer: tableRenderService.inlineTaskComment
				},
				{
					id: 'lastCommenter',
					display: 'Last Commenter',
					show: false,
					width: 120
				},
				{
					id: 'lastCommentDate',
					display: 'Last Comment Date',
					renderer: tableRenderService.dateRenderer,
					convertTimeZone: true,
					show: false,
					width: 120
				},
				{
					id: 'itemGroup',
					display: 'Item Group',
					width: 140,
					show: false
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				},
				{
					id: 'currentShortageDetectedDate',
					display: 'Days In Shortage',
					renderer: tableRenderService.daysOffset,
					addDay: true,
					width: 100,
					isReverseSort: true
				},
				{
					id: 'buyerCode',
					display: 'Buyer',
					width: 140
				},
				{
					id: 'shortageCriticalityLevelLabel',
					display: 'Criticality Level',
					width: 140,
					renderer: tableRenderService.shortageCriticalityLevel
				},
				{
					id: 'planner',
					display: 'Planner',
					width: 140,
					show: false
				},
				{
					id: 'supplierName',
					display: 'Supplier',
					width: 140,
					show: false
				},
				{
					id: 'firstPurchaseOrderSupplierName',
					display: 'Supply Order Supplier',
					width: 140,
					renderer: tableRenderService.firstPurchaseOrder,
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'supplierCode',
					display: 'Supply Order Supplier Code',
					width: 140,
					renderer: tableRenderService.firstPurchaseOrder,
					peggingTooltip: 'First supply order requiring attention',
					show: false
				},
				{
					id: 'firstPoStatus',
					display: 'Supply Order Status',
					width: 190,
					renderer: tableRenderService.inlineEdit,
					editType: 'poComment',
					disabled: enableForecastUI && globalConfig.customer.id !== 90,
					isPegged: true,
					peggingTooltip: 'Status of first supply order requiring attention'
				},
				{
					id: 'poStatusCategoryDescription',
					display: 'Supply Order Status Category',
					width: 100,
					sort: false,
					renderer: tableRenderService.inlineEdit,
					editType: 'poComment',
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'firstPurchaseOrderOriginalRequestedDate',
					display: 'Supply Order Requested Date',
					width: 100,
					renderer: tableRenderService.firstPurchaseOrder,
					title: 'The original Requested Date for the Order.',
					convertTimeZone: true,
					sortDefaultReverse: false,
					peggingTooltip: 'First supply order requiring attention',
					show: false
				}, {
					id: 'firstPurchaseOrderDateStatus',
					display: 'Supply Order Expected Delivery Date Status',
					width: 100,
					title: 'The committment level of the supply order requested date',
					convertTimeZone: true,
					sortDefaultReverse: false,
					peggingTooltip: 'Commitment level of the first supply order requested date',
					renderer: tableRenderService.confirmationStatusUsed,
					show: false
				},
				{
					id: 'impactedOrdersCount',
					display: 'Impacted Orders Count',
					width: 80
				},
				{
					id: 'firstImpactedOrder',
					display: isLobAllParts ? 'First Order Impacted by Shortage' : 'First Impacted Order',
					width: 140
				},
				{
					id: 'firstImpactedSalesOrderQty',
					display: isLobAllParts ? 'Qty Needed for First Sales Order Impacted by Shortage' : 'Qty Needed for First Impacted Sales Order',
					width: 140,
					show: !isLobAllParts
				},
				{
					id: 'leadTime',
					display: 'Lead Time',
					renderer: tableRenderService.leadTime,
					width: 80,
					sortDefaultReverse: true
				},
				{
					id: 'unitOfMeasure',
					display: 'UOM',
					width: 80
				},
				{
					id: 'totalOnHandBlocked',
					display: 'On Hand Blocked',
					width: 100,
					renderer: tableRenderService.hyperlinkShortage,
					show: !isLobAllParts
				},
				{
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'safetyStockFloat',
					display: 'Safety Stock',
					width: 80,
					renderer: tableRenderService.integer,
					show: !isLobAllParts
				},
				{
					id: 'firstPurchaseOrderErpStatus',
					display: 'Supply Order ERP Status',
					width: 190,
					renderer: tableRenderService.firstPurchaseOrderErpStatus,
					columnDependencies: ['firstPurchaseOrder'],
					peggingTooltip: 'First supply order requiring attention',
					show: false
				},
				{
					id: 'firstPurchaseOrderExceptionMsg',
					display: 'Supply Order Exception Message',
					width: 190,
					show: false,
					renderer: tableRenderService.firstPurchaseOrderExceptionMsg,
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'firstPurchaseOrderReScheduleDate',
					display: 'Supply Order Reschedule Date',
					width: 190,
					show: false,
					renderer: tableRenderService.firstPurchaseOrderReScheduleDate,
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'firstErpPoNotes',
					display: 'Supply Order ERP Notes',
					width: 400,
					show: false,
					renderer: tableRenderService.firstPurchaseOrder,
					peggingTooltip: 'First supply order requiring attention'
				},
				{
					id: 'firstImpactedLocation',
					display: isLobAllParts ? 'First Location Impacted by Shortage' : 'First Impacted Location',
					width: 140,
					show: false
				},
				{
					id: 'firstImpactedSalesOrder',
					display: isLobAllParts ? 'First Sales Order Impacted by Shortage' : 'First Impacted Sales Order',
					width: 140,
					show: false
				},
				{
					id: 'firstImpactedSalesOrderDate',
					display: isLobAllParts ? 'Date of First Sales Order Impacted by Shortage' : 'First Impacted Sales Order Date',
					width: 140,
					show: false,
					renderer: tableRenderService.dateRenderer,
					convertTimeZone: true
				},
				{
					id: 'erpOrderPolicy',
					display: 'ERP Order Policy',
					width: 80,
					show: false
				},
				{
					id: 'abcClass',
					display: 'ABC Rank',
					width: 80,
					show: false
				},
				{
					id: 'specialProcurementType',
					display: 'Special Procurement Type',
					width: 140,
					show: false
				},
				{
					id: 'analysisAvgDailyDemandFloat',
					display: 'Company Defined Demand (Daily)',
					width: 100,
					renderer: tableRenderService.hyperlinkShortage,
					show: false
				},
				{
					id: isSupplierConfig || isSupplier ? 'lastReceivedQtyMasterSupplier' : 'lastReceivedQty',
					display: 'Last Received Quantity',
					width: 80,
					show: false,
					renderer: tableRenderService.firstPurchaseOrder
				},
				{
					id: isSupplierConfig || isSupplier ? 'lastReceivedDateMasterSupplier' : 'lastReceivedDate',
					display: 'Last Received Date',
					width: 140,
					show: false,
					convertTimeZone: true,
					renderer: tableRenderService.firstPurchaseOrder
				},
				{
					id: 'lastReceivedSupplierName',
					display: 'Last Received Supplier',
					width: 140,
					show: false,
					renderer: tableRenderService.firstPurchaseOrder
				},
				{
					id: 'plannedOnOrderQuantity',
					display: 'Planned On Order',
					show: false,
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'firmedOnOrderQuantity',
					display: 'Firmed On Order',
					show: false,
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'minLevelFloat',
					display: 'Min Level',
					width: 80,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'maxLevelFloat',
					display: 'Max Level',
					width: 80,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'pastDueOnOrderQty',
					display: 'Past Due on Order',
					width: 100,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'pastDueRequirements',
					display: 'Past Due Demand',
					width: 100,
					renderer: tableRenderService.decimal,
					keepAllDecimals: true,
					show: !isLobAllParts
				},
				{
					id: 'totalDemand',
					display: 'Total Demand',
					show: false,
					width: 80,
					renderer: tableRenderService.integer
				},
				{
					id: 'onHandAtOtherSites',
					display: 'On Hand at Other Sites',
					show: false,
					width: 80,
					renderer: tableRenderService.excessAtOtherSites,
					sortDefaultReverse: true
				},
				{
					id: 'excessAtOtherSites',
					display: 'Excess at Other Sites',
					show: false,
					width: 80,
					renderer: tableRenderService.excessAtOtherSites,
					sortDefaultReverse: true
				}];
			
			if (supplyOrderForecastEnabled) {
				columns = columns.concat([{
					id: 'forecastDeliveryCount',
					display: 'Scheduled Deliveries',
					width: 100,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					disabled: !enableForecastUI,
					editable: true
				},
				{
					id: 'forecastTotalQuantity',
					display: 'Scheduled Quantity',
					width: 100,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					disabled: !enableForecastUI,
					editable: true
				},
				{
					id: 'forecastFirstDeliveryQuantity',
					display: 'First Delivery Quantity',
					width: 80,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					disabled: !enableForecastUI,
					editable: true
				},
				{
					id: 'forecastFirstComment',
					display: 'First Delivery Comment',
					width: 80,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					convertTimeZone: true,
					disabled: !enableForecastUI,
					editable: true
				},
				{
					id: 'forecastFirstDeliveryDate',
					display: 'First Delivery Date',
					width: 80,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					convertTimeZone: true,
					disabled: !enableForecastUI,
					editable: true
				}, {
					id: 'forecastFirstTrackingNumber',
					display: 'First Delivery Tracking Number',
					width: 80,
					sort: true,
					renderer: tableRenderService.forecastDelivery,
					convertTimeZone: true,
					disabled: !enableForecastUI,
					editable: true
				}]);
			} else {
				columns = columns.concat([{
					id: 'firstPoEcdDate',
					display: 'Supply Order Commit Date',
					show: true,
					width: 100,
					renderer: tableRenderService.inlineEditDate,
					disabled: enableForecastUI,
					isPegged: true,
					peggingTooltip: 'Commit date of first supply order requiring attention',
					showApprovalModal: true
				},
				{
					id: 'firstPoTrackingNumber',
					display: 'Supply Order Tracking Number',
					width: 190,
					renderer: tableRenderService.inlineEdit,
					editType: 'poComment',
					disabled: enableForecastUI || siteService.isSpiritSupplier(),
					isPegged: true,
					peggingTooltip: 'Tracking number of first supply order requiring attention',
					show: !isLobAllParts
				},
				{
					id: 'firstPoEcdLastModified',
					display: 'Last Supply Order Commit Date Update',
					width: 100,
					sort: true,
					isReverseSort: true,
					renderer: tableRenderService.relativeDate,
					disabled: enableForecastUI,
					show: false
				}]);
			}

			columns = columns.concat([
				{
					id: 'quantityInClearToBuildWindow',
					display: 'Qty in LOB supply exclusion window',
					show: false,
					width: 120,
					renderer: tableRenderService.decimal
				},
				{
					id: 'ctbShortageImpactedValue',
					display: 'CTB Shortage Impacted Value',
					disabled: !clearToBuildv2Enabled,
					width: 110,
					renderer: tableRenderService.ctbImpactedOrdersRenderer
				},
				{
					id: 'ctbImpactedOrdersSingleShortageCount',
					display: 'CTB Impacted Orders (as single shortage)',
					disabled: !clearToBuildv2Enabled,
					width: 110,
					renderer: tableRenderService.ctbImpactedOrdersRenderer
				},
				{
					id: 'currentReOrderPoint',
					display: 'Reorder Point',
					width: 100,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'currentReOrderQty',
					display: 'Reorder Qty',
					width: 100,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'recommendedReorderPointInt',
					display: 'Recommended Reorder Point',
					width: 120,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'recommendedReorderQtyFloat',
					display: 'Recommended Reorder Qty',
					width: 120,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'daysOnHand',
					display: 'Days on Hand (Days)',
					width: 80,
					daysDisplay: 'Days',
					renderer: tableRenderService.daysNoConversion
				},
				{
					id: 'daysCoverage',
					display: 'Days Coverage (Work Days)',
					width: 80,
					daysDisplay: 'Work Days',
					renderer: tableRenderService.daysNoConversion,
					show: false
				},
				{
					id: 'monthsCoverage',
					display: 'Months of coverage',
					width: 80,
					renderer: tableRenderService.integer,
					show: false
				},
				{
					id: 'itemNote',
					display: 'Item notes',
					width: 150,
					renderer: tableRenderService.string,
					show: false
				}]);

			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			if (addLobDefinition) {
				columns.push({
					id: 'LOB',
					display: 'Line of Balance'
				});
			}
			columns = columns.concat([
				{
					id: 'firstCriticalBucket',
					display: 'Week of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalWeek,
					disabled: true,
					bucket: 'weeks'
				},
				{
					id: 'firstCriticalBucketMonth',
					display: 'Month of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalMonth,
					disabled: true,
					bucket: 'months',
					show: false
				},
				{
					id: 'firstCriticalBucketDay',
					display: 'Day of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalDay,
					disabled: true,
					bucket: 'days',
					show: false
				},
				{
					id: 'aggregateRiskScore',
					display: 'Aggregate Risk Score',
					width: 80,
					renderer: tableRenderService.aggregateRiskScoreRenderer,
					sort: true,
					show: false
				},
				{
					id: 'aggregateRiskScoreLabel',
					display: 'Risk Level',
					width: 160,
					sort: true,
					show: false
				},
				{
					id: 'reqmtToday',
					display: 'Net Quantity',
					width: 100,
					renderer: tableRenderService.bucket
				}
			]);

			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getShortageByOrderColumns(isSupplierConfig, isSupplier, isAllowed, enableForecastUI, isBombardierUser) {
			var columns = columnsService({
				orderNumber: { show: 1, pinnedLeft: 1, pinnedPosition: 2 },
				requirementDate: { show: 1, pinnedLeft: 1, pinnedPosition: 3 },
				requirementQty: 1,
				shortageQty: 0,
				productionOrder: 1,
				operationsNumber: 1,
				prodOrderPriority: 1,
				prodOrderStatus: 1,
				prodOrderCommitDateString: 1,
				prodOrderCommitDateLastModified: 0,
				prodOrderDropDeadDate: 1,
				prodOrderOperationsComment: 0,
				criticalIndicator: 1,
				criticalPart: 0,
				itemCode: { show: 1, pinnedLeft: 1, pinnedPosition: 1 },
				factoryName: { show: 0, sort: false },
				location: 0,
				workcenter: { show: 0, sort: isBombardierUser },
				requirementType: 0,
				buyerCode: { show: 0, sort: isBombardierUser },
				planner: { show: 0, sort: isBombardierUser },
				supplierName: { show: 0, sort: isBombardierUser },
				supplierCode: { show: 0, sort: isBombardierUser },
				orderDate: { display: 'Order Date', show: 0, sort: false },
				goldenSupplyDate: 'Expected Delivery Date',
				confirmationStatusUsed: 0,
				originalRequestedDate: 0,
				firstPoStatus: { show: 1, sort: false, disabled: enableForecastUI && globalConfig.customer.id !== 90, checkTmq: true },
				poNotes: {show: 0, display: 'PO Notes'},
				purchaseOrderNumber: { show: 1, sort: isBombardierUser, display: 'PO Number' },
				purchaseOrderLine: { show: 1, sort: false, display: 'PO Line' },
				poStatusCategoryDescription: {show: 0, sort: false },
				scheduleLine: { show: 1, sort: false },
				remainingQuantity: { show: 0, sort: false },
				parentAssembly: { show: 0, sort: isBombardierUser },
				itemType: { show: 0, sort: false },
				totalOnHandUnrestrictedQuantity: 0,
				erpType: 0,
				erpOrderPolicy: { show: 0, sort: false },
				poErpStatus: { show: 0, sort: false },
				actionStatus: { show: 0, sort: false },
				actionCategory: { show: 0, sort: false },
				actionOwner: { show: 0, sort: false },
				actionDueDate: { show: 0, sort: false },
				lastComment: { show: 0, sort: false },
				lastCommenter: { show: 0, sort: false },
				lastCommentDate: { show: 0, sort: false },
				excessAtOtherSites: 0,
				endItemCode: 0,
				endItemAlias: 0,
				endItemDescription: 0,
				endItemPlanner: 0,
				aggregateRiskScore: 0,
				aggregateRiskScoreLabel: 0,
				requirementStatus: { show: 0, sort: false }
			});
			if (supplyOrderForecastEnabled) {
				columns = columns.concat(columnsService({
					forecastTotalQuantity: 0,
					forecastDeliveryCount: 0,
					forecastFirstDeliveryQuantity: 0,
					forecastFirstDeliveryDate: 0,
					forecastFirstTrackingNumber: 0,
					forecastFirstComment: 0
				}));
			} else {
				columns = columns.concat(columnsService({
					firstPoTrackingNumber: { show: 0, disabled: enableForecastUI },
					firstPoEcdDate: { show: true, showApprovalModal: true, sort: isBombardierUser, disabled: enableForecastUI, checkTmq: true },
					firstPoEcdLastModified: { show: 0, sort: isBombardierUser, disabled: enableForecastUI }
				}));
			}

			columns = flexColumns.addFlexColumnsBySourceType(['item', 'supply'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getSupplierPerformanceLastMonthColumns(isSupplierConfig, isSupplier, reportRenderers) {
			var columns = getSupplierPerformanceColumns(false, reportRenderers);
			columns.push({
				'id': 'delperfmonth3',
				'display': 'Delivery Score',
				'width': 143,
				'forceWidth': 143,
				'renderer': reportRenderers.delPerfRenderer,
				'includeTrendLine': true,
				'title': 'The average delivery score for last month',
				'extraFormat': 'percentage',
				'showSOTD': true,
				'disabled': !scorecardSettings.scorecardDelPerfEnabled
			});
			columns.push({
				'id': 'delPerfDaysLateMonth3',
				'display': 'Avg Days Late',
				'width': 80,
				'class': 'numberCell alignRight',
				'renderer': reportRenderers.daysLateRenderer,
				'sortDefaultReverse': true,
				'title': 'The average number of days late for all late deliveries'
			});
			columns.push({
				'id': 'delperfearlymonth3',
				'display': 'Early Delivery Score',
				'class': 'numberCell veryLargeTitle alignRight',
				'width': 100,
				'show': false,
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'The percent of deliveries last month that were early',
				'extraFormat': 'percentage',
				'sortDefaultReverse': true,
				'disabled': !scorecardSettings.scorecardDelPerfEarlyEnabled
			});
			columns.push({
				'id': 'delperflatemonth3',
				'display': 'Late Delivery Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'show': false,
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'The percent of deliveries last month that were late',
				'extraFormat': 'percentage',
				'sortDefaultReverse': true,
				'disabled': !scorecardSettings.scorecardDelPerfLateEnabled
			});
			columns.push({
				'id': 'combinedDeliveryPerf',
				'display': 'MinMax Delivery Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'Average of MinMax scores for last month',
				'extraFormat': 'percentage',
				'disabled': !scorecardSettings.scorecardVmiOverMaxPerfEnabled && !scorecardSettings.scorecardVmiBelowMinPerfEnabled
			});
			columns.push({
				'id': 'qualityperfmonth3',
				'display': 'Quality Score (DPPM)',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'show': false,
				'title': 'Defective Parts Per Million (DPPM) for last month',
				'renderer': tableRenderService.perfRenderer,
				'disabled': !scorecardSettings.scorecardQualityPerfEnabled
			});
			columns.push({
				'id': 'costperfmonth3',
				'display': 'Cost Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'title': 'The average increase/decrease in pricing for last month',
				'renderer': tableRenderService.perfRenderer,
				'extraFormat': 'percentage',
				'sortDefaultReverse': true,
				'disabled': !scorecardSettings.scorecardCostPerfEnabled
			});
			for (var bucket = 1; bucket <= 12; bucket++) {
				var monthLabel = moment().subtract(bucket, 'month').format('MMM YYYY');
				columns.push({
					'id': 'delPerfMonthBucket' + bucket,
					'display': $translate.instant('Delivery Score') + ' ' + monthLabel,
					'deliveryScoreMonthLabel': monthLabel,
					'width': 143,
					'forceWidth': 143,
					'class': 'numberCell alignRight',
					'show': false,
					'renderer': reportRenderers.delPerfRenderer,
					'title': 'Percent of deliveries on time during period ' + bucket + ' month' + (bucket > 1 ? 's' : '') + ' ago.',
					'extraFormat': 'percentage',
					'disabled': !scorecardSettings.scorecardDelPerfEnabled
				});
			}
			columns = _.concat(columns, getSupplierPerformanceColumns(true, reportRenderers));
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getSupplierPerformanceRollingAverageColumns(isSupplierConfig, isSupplier, reportRenderers) {
			var columns = getSupplierPerformanceColumns(false, reportRenderers);
			columns.push({
				'id': 'delperfrollingavg',
				'display': 'Delivery Score',
				'width': 143,
				'forceWidth': 143,
				'renderer': reportRenderers.delPerfRenderer,
				'includeTrendLine': true,
				'title': 'The rolling average delivery score for last 12 months',
				'extraFormat': 'percentage',
				'showSOTD': true,
				'disabled': !scorecardSettings.scorecardDelPerfEnabled
			});
			columns.push({
				'id': 'delPerfDaysLateRollingAvg',
				'display': 'Avg Days Late',
				'width': 80,
				'class': 'numberCell alignRight',
				'renderer': reportRenderers.daysLateRenderer,
				'sortDefaultReverse': true,
				'title': 'The average number of days late for all late deliveries'
			});
			columns.push({
				'id': 'delperfearlyrollingavg',
				'display': 'Early Delivery Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'show': false,
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'The percent of deliveries last 12 months that were early',
				'extraFormat': 'percentage',
				'disabled': !scorecardSettings.scorecardDelPerfEarlyEnabled
			});
			columns.push({
				'id': 'delperflaterollingavg',
				'display': 'Late Delivery Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'show': false,
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'The percent of deliveries last 12 months that were late',
				'extraFormat': 'percentage',
				'disabled': !scorecardSettings.scorecardDelPerfLateEnabled
			});
			columns.push({
				'id': 'combinedDeliveryPerfRollingAvg',
				'display': 'MinMax Delivery Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'renderer': reportRenderers.delPerfRenderer,
				'title': 'The rolling average of MinMax scores for last 12 months',
				'extraFormat': 'percentage',
				'disabled': !scorecardSettings.scorecardVmiOverMaxPerfEnabled && !scorecardSettings.scorecardVmiBelowMinPerfEnabled
			});
			columns.push({
				'id': 'qualityperfrollingavg',
				'display': 'Quality Score (DPPM)',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'show': false,
				'title': 'Rolling average of Defective Parts Per Million (DPPM) for last 12 months',
				'renderer': tableRenderService.perfRenderer,
				'sortDefaultReverse': true,
				'disabled': !scorecardSettings.scorecardQualityPerfEnabled
			});
			columns.push({
				'id': 'costperfrollingavg',
				'display': 'Cost Score',
				'width': 100,
				'class': 'numberCell veryLargeTitle alignRight',
				'title': 'The rolling average increase/decrease in pricing for last 12 months',
				'renderer': tableRenderService.perfRenderer,
				'extraFormat': 'percentage',
				'disabled': !scorecardSettings.scorecardCostPerfEnabled
			});
			for (var bucket = 1; bucket <= 12; bucket++) {
				var monthLabel = moment().subtract(bucket, 'month').format('MMM YYYY');
				columns.push({
					'id': 'delPerfMonthBucket' + bucket,
					'display': $translate.instant('Delivery Score') + ' ' + monthLabel,
					'deliveryScoreMonthLabel': monthLabel,
					'width': 143,
					'forceWidth': 143,
					'class': 'numberCell alignRight',
					'show': false,
					'renderer': reportRenderers.delPerfRenderer,
					'title': 'Percent of deliveries on time during period ' + bucket + ' month' + (bucket > 1 ? 's' : '') + ' ago.',
					'extraFormat': 'percentage',
					'disabled': !scorecardSettings.scorecardDelPerfEnabled
				});
			}
			columns = _.concat(columns, getSupplierPerformanceColumns(true, reportRenderers));
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getSupplierPerformanceColumns(isWeekly, reportRenderers) {
			if (!isWeekly) {
				return [
					{
						'id': 'supplierName',
						'display': 'Supplier',
						'width': 225,
						'class': 'twoTwentyFiveCell expander',
						'title': '',
						'renderer': reportRenderers.supplierScorecardDrilldownRenderer
					},
					{
						'id': 'factoryName',
						'display': 'Site',
						'width': 225,
						'show': true,
						'disabled': true
					},
					{
						'id': 'supplierCode',
						'display': 'Supplier Code',
						'class': 'textCell',
						'width': 72,
						'show': false,
						'title': ''
					},
					{
						'id': 'totalOnHandInv',
						'display': 'Total Inventory',
						'class': 'numberCell veryLargeTitle alignRight',
						'width': 100,
						'renderer': tableRenderService.currency,
						'title': '',
						'sortDefaultReverse': true
					},
					{
						'id': 'totalSpend',
						'display': 'Spend Current Fiscal Year',
						'class': 'numberCell alignRight veryLargeTitle',
						'renderer': tableRenderService.currency,
						'width': 100,
						'sortDefaultReverse': true
					},
					{
						'id': 'totalOnOrderInv',
						'display': 'On Order Value',
						'class': 'numberCell veryLargeTitle alignRight',
						'width': 100,
						'title': '',
						'renderer': tableRenderService.currency,
						'sortDefaultReverse': true
					},
					{
						'id': 'avgLeadTime',
						'display': 'Avg Lead Time',
						'class': 'numberCell alignRight',
						'width': 100,
						'show': false,
						'title': '',
						'renderer': tableRenderService.leadTime,
						'sortDefaultReverse': true
					},
					{
						'id': 'numberOfItems',
						'display': 'Total Items Supplied',
						'class': 'numberCell largeTitle alignRight',
						'width': 100,
						'show': false,
						'title': '',
						'sortDefaultReverse': true
					},
					{
						'id': 'tgtInv',
						'display': '6 Month Burnoff Target',
						'class': 'numberCell alignRight veryLargeTitle',
						'renderer': tableRenderService.targetInventoryRenderer,
						'width': 100,
						'sortDefaultReverse': true
					},
					{
						'id': 'openInventoryActions',
						'display': 'Open Inventory Actions',
						'class': 'numberCell alignRight veryLargeTitle',
						'renderer': tableRenderService.inventoryActionsRenderer,
						'width': 100,
						'show': false,
						'sortDefaultReverse': true
					}
				];
			} else {
				return [
					{
						'id': 'wkDeltaOnHandInventory',
						'display': 'Weekly Change On Hand Inventory',
						'width': 120,
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'show': false,
						'extraFormat': 'currency',
						'sortDefaultReverse': true
					},
					{
						'id': 'wkDeltaExcessInventory',
						'display': 'Weekly E&O On Hand Change',
						'width': 120,
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'extraFormat': 'currency',
						'sortDefaultReverse': true
					},{
						'id': 'wkDeltaExcessOnOrder',
						'display': 'Weekly Change Excess On Order',
						'width': 120,
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'show': false,
						'extraFormat': 'currency',
						'sortDefaultReverse': true
					},{
						'id': 'wkDeltaOverMax',
						'width': 120,
						'display': 'Weekly Change Inventory Over Max',
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'show': false,
						'extraFormat': 'currency',
						'sortDefaultReverse': true
					},{
						'id': 'wkDeltaShortages',
						'display': 'Weekly Change Shortages',
						'width': 120,
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'wkDeltaUnderMin',
						'display': 'Weekly Change Items Under Min',
						'width': 120,
						'class': 'numberCell deltaValues alignRight',
						'renderer': tableRenderService.deltaPerformanceRenderer,
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'excessInventory',
						'display': 'Excess Inventory',
						'width': 120,
						'class': 'numberCell veryLargeTitle alignRight',
						'show': false,
						'renderer': tableRenderService.currency,
						'sortDefaultReverse': true
					},{
						'id': 'excessOnOrder',
						'display': 'Excess On Order',
						'width': 120,
						'class': 'numberCell veryLargeTitle alignRight',
						'renderer': tableRenderService.currency,
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'inventoryOverMax',
						'display': 'Inventory Over Max',
						'width': 120,
						'class': 'numberCell veryLargeTitle alignRight',
						'renderer': tableRenderService.currency,
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'itemsUnderMin',
						'display': 'Items Under Min',
						'width': 120,
						'class': 'numberCell alignRight',
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'itemsShort',
						'display': 'Shortages',
						'width': 120,
						'class': 'numberCell alignRight',
						'show': false,
						'sortDefaultReverse': true
					},{
						'id': 'noOfPosWithMissingCommitDate',
						'display': '# of non-compliant POs (missing date)',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.workbenchNonCompliantPoRenderer,
						'nonCompliantType': 'missingCommitDate',
						disabled: !$experiments.isEnabled('workbench')
					},{
						'id': 'noOfPosWithPastDueCommitDate',
						'display': '# of non-compliant POs (past due date)',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.workbenchNonCompliantPoRenderer,
						'nonCompliantType': 'pastDueCommitDate',
						disabled: !$experiments.isEnabled('workbench')
					},{
						'id': 'noOfPosWithRejectedCommitDate',
						'display': '# of non-compliant POs (rejected date)',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.workbenchNonCompliantPoRenderer,
						'nonCompliantType': 'rejectedCommitDate',
						disabled: !$experiments.isEnabled('workbench')
					},{
						'id': 'noOfPosWithAdjustment',
						'display': '# of non-compliant adjustment requests',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.workbenchNonCompliantPoRenderer,
						'nonCompliantType': 'adjustmentRequest',
						disabled: !$experiments.isEnabled('workbench')
					},{
						'id': 'commitDateCoverage',
						'display': 'Compliance %',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.commitDateCoverageRenderer,
						disabled: !$experiments.isEnabled('workbench')
					},{
						'id': 'accuracyLast30Days',
						'display': 'Accuracy last 30 days',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.percent
					},{
						'id': 'supplierCommitDatePercent',
						'display': 'Supplier-added commit date %',
						'class': 'buyerCell',
						'width': 150,
						'show': true,
						renderer: tableRenderService.percent
					},{
						'id': 'activeSupplierUsers',
						'display': 'Weekly active suppliers',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.integer
					},{
						'id': 'engagedSupplierUsers',
						'display': 'Weekly engaged suppliers',
						'class': 'buyerCell',
						'width': 150,
						renderer: tableRenderService.integer
					},{
						'id': 'daysSinceLastAccess',
						'display': 'Last Access',
						'class': 'buyerCell',
						'width': 150,
						renderer: reportRenderers.daysSinceLastAccessRenderer,
						'sortDefaultReverse': true
					},{
						'id': 'componentAvailabilityPercent',
						'display': 'Component Availability % ',
						'class': 'numberCell alignRight veryLargeTitle',
						'renderer': tableRenderService.percent,
						'width': 150,
						'show': false
					},{
						'id': 'componentAvailabilityPercentProjected',
						'display': 'Component Availability % (projected)',
						'class': 'numberCell alignRight veryLargeTitle',
						'renderer': tableRenderService.percent,
						'width': 150,
						'show': false
					},{
						'id': 'internationalFlag',
						'display': 'International Supplier',
						'class': 'buyerCell',
						'renderer': tableRenderService.yesNo,
						'width': 150,
						'show': true
					}
				];
			}
		}

		function getItemReportMinMaxUnderMinColumns(isSupplierConfig, isSupplier) {
			var columns = [{
				'id': 'actionStatus',
				'display': 'Task Status',
				'width': 100,
				'renderer': tableRenderService.status
			},
			{
				'id': 'itemCode',
				'display': 'Item Code',
				'width': 200,
				'renderer': tableRenderService.itemCode
			}, {
				'id': 'factoryName',
				'display': 'Site',
				'width': 120
			},
			{
				'id': 'supplierName',
				'display': 'Supplier',
				'width': 200
			},
			{
				'id': 'totalOnHandUnrestrictedQuantity',
				'display': 'On Hand (Unrestricted)',
				'width': 100,
				'renderer': tableRenderService.hyperlinkShortage
			},
			{
				'id': 'totalOnHandConsignmentQuantity',
				'display': 'Consignment Qty',
				'renderer': tableRenderService.hyperlinkShortage
			},
			{
				'id': 'minLevelFloat',
				'display': 'Min Level',
				'width': 100,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'maxLevelFloat',
				'display': 'Max Level',
				'width': 100,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'leadTimeInDaysFloat',
				'display': 'Lead Time',
				'width': 100,
				'renderer': tableRenderService.leadTime,
				'sortDefaultReverse': true
			},
			{
				'id': 'totalOnHandQuantityFloat',
				'display': 'Total On Hand Qty',
				'show': false,
				'width': 100,
				'renderer': tableRenderService.hyperlinkShortage
			},
			{
				'id': 'totalOnOrderQuantityFloat',
				'display': 'On Order Qty',
				'width': 100,
				'renderer': tableRenderService.hyperlinkShortage
			},
			{
				'id': 'analysisReplenishmentType',
				'display': 'Recommended Policy',
				'width': 100
			},
			{
				'id': 'calculatedMinLevel',
				'display': 'Recommended Min Level',
				'width': 100,
				'renderer': tableRenderService.integer,
				'show': false
			},
			{
				'id': 'calculatedMaxLevel',
				'display': 'Recommended Max Level',
				'width': 100,
				'renderer': tableRenderService.integer,
				'show': false
			},
			{
				'id': 'analysisAvgMonthlyDemandFloat',
				'display': 'Company Defined Demand (Monthly)',
				'width': 100,
				'show': false,
				'renderer': tableRenderService.avgPeriodicDemand
			},
			{
				'id': 'buyerCode',
				'display': 'Buyer',
				'width': 100,
				'show': false
			},
			{
				'id': 'productHierarchy',
				'display': 'Product Hierarchy',
				'width': 100,
				'show': false
			},
			{
				'id': 'externalMaterialGroup',
				'display': 'External Material Group',
				'width': 100,
				'show': false
			},
			{
				'id': 'costPerItemFloat',
				'display': 'Unit Price',
				'width': 100,
				'renderer': tableRenderService.currency,
				'show': false
			}, {
				id: 'materialType',
				display: 'Material Type',
				show: false,
				width: 80
			}, {
				id: 'materialGroup',
				display: 'Material Group',
				show: false,
				width: 80
			}];
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getItemReportUnderSafetyStockColumns(isSupplierConfig, isSupplier) {
			var columns = columnsService({
				actionStatus: 0,
				itemCode: 1,
				factoryName: 1,
				erpOrderPolicy: 0,
				supplierName: 1,
				buyerCode: 0,
				planner: 1,
				totalOnHandUnrestrictedQuantity: 'On Hand (Unrestricted)',
				totalOnHandConsignmentQuantity: 0,
				safetyStockFloat: 1,
				maxLevelFloat: 0,
				currentReOrderPoint: 1,
				currentReOrderQty: 1,
				leadTimeInDaysFloat: {
					sortDefaultReverse: true
				},
				totalOnHandQuantityFloat: 0,
				totalOnOrderQuantityFloat: 1,
				analysisReplenishmentType: 0,
				analysisSafetyStockLevelFloat: 0,
				recommendedReorderPointInt: 0,
				recommendedReorderQtyFloat: 0,
				analysisAvgDailyDemandFloat: 0,
				averageDailyDemandFromPastRqmts: 0,
				averageDailyDemandFromFutureRqmts: 0
			});
			columns = columns.concat(columnsService({
				productHierarchy: 0,
				externalMaterialGroup: 0,
				materialGroup: 0,
				materialType: 0,
				costPerItemFloat: 0
			}));
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getItemReportTargetSavingsColumns(isSupplierConfig, isSupplier) {
			return getItemReportTargetSavingsColumns(isSupplierConfig, isSupplier, false);
		}

		function getItemReportTargetSavingsColumns(isSupplierConfig, isSupplier, isPfepAllParts) {
			var columns = columnsService({
				actionStatus: 0,
				itemCode: 1,
				factoryName: 0,
				analysisAverageDailyCostFloat: 0,
				actionCategory: 0,
				supplierName: 1,
				totalOnHandUnrestrictedConsignmentQuantity: 0,
				totalOnHandConsignmentQuantity: {
					display: 'Consignment Qty',
					show: false,
					width: 80
				},
				overMaxValue: 0,
				totalOnHandUnrestrictedQuantity: 0,
				analysisTargetInventoryQty: 0,
				estimatedSavings: 0,
				potentialSavings: 0
			});
			if ($rootScope.authz.isLeanDNAAdmin()) {
				columns = columns.concat(columnsService({
					currentVsPotential: 0,
					inventoryActionAssigned: 0
				}));
			}
			columns = columns.concat(columnsService({
				weeklyOpportunityDelta: 0,
				next30Days: 0,
				next60Days: 0,
				next90Days: 0,
				totalOnOrderQuantityFloat: {
					show: false,
					width: 80
				},
				totalOnOrderValue: 0,
				ctbShortageImpactedValue : {
					show: 0,
					disabled: !clearToBuildv2Enabled
				},
				ctbImpactedOrdersSingleShortageCount: {
					show: 0,
					disabled: !clearToBuildv2Enabled
				},
				buyerCode: 1,
				planner: 1,
				erpOrderPolicy: 1,
				orderPolicy: 0,
				analysisReplenishmentType: 1,
				abcClass: 1,
				abcAnalysisType: 1,
				analysisXYZClass: 0,
				totalOnHandQuantityFloat: {
					renderer: tableRenderService.integer,
					show: false,
					width: 80
				},
				currentOnHandCostFloat: 0,
				daysOfInventoryBackwards: 0,
				daysOfInventoryForwards: 0,
				purchasingUOM: 1,
				leadTimeInDaysFloat: 1,
				minLevelFloat: 0,
				maxLevelFloat: {
					show: false,
					width: 80
				},
				safetyStockFloat: 1,
				analysisSafetyStockLevelFloat: 1,
				currentReOrderPoint: {
					show: false,
					width: 80
				},
				currentReOrderQty: 0,
				recommendedReorderPointInt: {
					show: false,
					width: 80
				},
				recommendedReorderQtyFloat: {
					show: false,
					width: 80
				},
				analysisAvgMonthlyDemandFloat: 0,
				analysisAvgDailyDemandFloat: 0,
				averageMonthlyDemandFromPastRqmts: 0,
				averageDailyDemandFromPastRqmts: 0,
				averageMonthlyDemandFromFutureRqmts: 0,
				averageDailyDemandFromFutureRqmts: 0,
				calculatedMinLevel: 0,
				calculatedMaxLevel: 0,
				productHierarchy: {
					show: false,
					width: 80
				},
				orderIntervalInt: 0,
				analysisOrderIntervalInt: 0,
				minimumOrderQuantityFloat: 1,
				futureDemandThisWeek: 0,
				futureDemandWeeklyChangePercent: 0,
				futureDemandWeeklyChangeValue: 0,
				analysisABCMOQFloat: 1,
				orderMultipleFloat: 0,
				recommendedLotSize: 0,
				costPerItemFloat: 1,
				standardPrice: 1,
				itemGroupName: 1,
				materialGroup: 1,
				materialType: 1,
				externalMaterialGroup: 0,
				totalShortageOccurrences: 0,
				numDaysAsAShortage: 0,
				averageDaysInShortage: 0,
				maxDaysInShortage: 0,
				aggregateRiskScore: 0,
				aggregateRiskScoreLabel: 0
			}));
			if(isPfepAllParts){
				columns = columns.concat(columnsService({
					demandCoefficientOfVariation: 0
				}));
			}
			columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getWorkbenchReportColumns(isSupplier) {
			var columns = columnsService({
				state: 'Status',
				poIdentifier: 0,
				itemCode: 1,
				factoryAlias: 1,
				goldenSupplyDate: 1,
				supplyOrderNumber: 'PO Number',
				orderLine: 'PO Line',
				scheduleLine: 1,
				firstPoStatus: 1,
				workbenchPriority: 1,
				requestedShippingDate: 0,
				confirmedShippingDate: 0,
				actualShippedDate: 0,
				incoterms: 0
			});
			if (!supplyOrderForecastEnabled) {
				columns = columns.concat(columnsService({
					firstPoTrackingNumber: 1,
					firstPoEcdDate: {show: true, showApprovalModal: true}
				}));
			}
			return isSupplier ? getSupplierAllowedColumns(columns): columns;
		}

		function getRequiredColumns() {
			var requiredColumns = [];

			angular.forEach(supplierReports, function (supplierReports, groupName) {
				angular.forEach(supplierReports, function (report) {
					var reportColumns = report.columns(true, false, true, report.additionalFlag);
					angular.forEach(reportColumns, function (reportColumn) {
						if (reportColumn.requiredForReport) {
							requiredColumns.push(reportColumn.id);
						}
					});
				});
			});
			return requiredColumns;
		}

		function getSupplierReportColumns() {
			var allReportColumns = {};

			angular.forEach(supplierReports, function (supplierReports, groupName) {
				allReportColumns[groupName] = {};
				angular.forEach(supplierReports, function (report) {
					var reportColumns = report.columns(true, false, true, report.additionalFlag);
					allReportColumns[groupName][report.name] = { idToName: {}, nameToId: {} };
					var columnDefinitions = allReportColumns[groupName][report.name];
					angular.forEach(reportColumns, function (reportColumn) {
						if (EXCLUDED_ACTION_COLUMNS.indexOf(reportColumn.id) === -1 && !reportColumn.disabled && reportColumn.id) {
							setColumnDefinition(columnDefinitions['idToName'], reportColumn.display, reportColumn.id);
							setColumnDefinition(columnDefinitions['nameToId'], reportColumn.id, reportColumn.display);
						}
					});
				});
			});
			return allReportColumns;
		}

		function setColumnDefinition(columnDefinition, key, value) {
			columnDefinition[key] = value;
		}

		function getSupplierAllowedColumns(columns) {
			var allowedColumns = _.uniq(_.concat(globalConfig.user.allowedColumns['allowed'] || [], globalConfig.user.allowedColumns['default'] || []));
			var reportColumns =  _.filter(columns, function (column) {
				return allowedColumns.indexOf(column.id) !== -1;
			});
			return reportColumns;
		}
	}
})();
